import { create } from "zustand";
import { loginProcess } from "../../apiEndpoints/navutils";
import { sendOtp, verifyOtp } from "../../apiEndpoints/navutils";

type SignUpState = {
    user: any
    fullName: string;
    email: string;
    password: string;
    confirmedPassword: string;
    otp: string,
    showModal: boolean,
    modalLoading: boolean,
    otpVerified: boolean,
    showPassword: boolean;
    showConfirmedPassword: boolean;
    hideActivityIndicator: boolean,

    setFullName: (value: string) => void;
    setEmail: (value: string) => void;
    setPassword: (value: string) => void;
    setConfirmedPassword: (value: string) => void;

    toggleShowPassword: () => void;
    toggleShowConfirmedPassword: () => void;

    handleSignupBtn: (SignUpFinished: (user: any) => void) => void
    sendOtp: (taskCompleted: () => void) => void,
    verfiyOtp: (taskCompleted: () => void) => void,
    setOtp: (otp: string) => void,
    toggleModel: () => void,
    toggleLoading: () => void,
    toggleOtpVerified: () => void,
    toggleActivityIndicator: () => void;
};

async function handleSignupProcess
    (fullName: string, email: string, password:
        string, confirmedPassword: string): Promise<any> {

    if (!fullName || !email || !password || !confirmedPassword) {
        window.alert("All fields are required");
        return undefined;
    }

    if (password !== confirmedPassword) {
        window.alert("Passwords do not match");
        return undefined;
    }

    const response = await fetch("/signup", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({
            name: fullName,
            email,
            password,
            password_confirmation: confirmedPassword,
        }),
    });
    const data = await response.json();
    if (data.message) {
        return true
    } else {
        window.alert(data.error);
        return undefined;
    }

}



export const useSignUpStore = create<SignUpState>((set, get) => ({
    hideActivityIndicator: false,
    otpVerified: false,
    modalLoading: false,
    user: null,
    fullName: "",
    email: "",
    password: "",
    confirmedPassword: "",
    otp: "",
    showModal: false,
    showPassword: false,
    showConfirmedPassword: false,


    setFullName: (value) => set({ fullName: value }),
    setEmail: (value) => {
        set({ email: value })
    },
    setPassword: (value) => set({ password: value }),
    setConfirmedPassword: (value) =>
        set({ confirmedPassword: value }),

    toggleShowPassword: () =>
        set((state) => ({
            showPassword: !state.showPassword,
        })),

    toggleShowConfirmedPassword: () =>
        set((state) => ({
            showConfirmedPassword: !state.showConfirmedPassword,
        })),

    handleSignupBtn: async (SignUpFinished) => {
        const { fullName, email, password, confirmedPassword } = get();
        const result = await handleSignupProcess(fullName, email, password, confirmedPassword);
        if (result) {
            SignUpFinished(result);
        } else {
            set({ hideActivityIndicator: false })
        }
    },
    sendOtp: async (taskCompleted) => {
        const { email } = get();
        const result = await sendOtp(email, "new");
        if (result) {
            taskCompleted()
        } else {
            set({ hideActivityIndicator: false })
        }
    },
    verfiyOtp: async (taskCompleted) => {
        const { email, otp } = get();
        const result = await verifyOtp(email, otp);
        if (result) {
            taskCompleted()
        } else {
            set({ modalLoading: false })
            set({ otp: "" })
        }
    },
    toggleModel: () =>
        set((state) => ({
            showModal: !state.showModal,
        })),
    setOtp: (otp) => set({ otp }),

    toggleLoading: () =>
        set((state) => ({
            modalLoading: !state.modalLoading,
        })),

    toggleOtpVerified: () => {
        set((state) => ({
            otpVerified: !state.otpVerified,
        }))
    },
    toggleActivityIndicator: () => {
        set((state) => ({
            hideActivityIndicator: !state.hideActivityIndicator,
        }))
    }



}));

